import './App.css';
import TextForm from './components/TextForm';
import About from './components/About';
import Navbar from './components/Navbar';
import Alert from './components/Alert';
import { useState } from 'react';

import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';

function App() {
  const [mode, setMode] = useState("light");
  const [alert, setAlert] = useState(null);

  const showAlert = (message, type) => {
    setAlert({
      msg: message,
      type: type
    })
    setTimeout(()=>{
      setAlert(null);
    },2000);
  }

  const toggleMode = () => {
    if (mode === "light") {
      setMode("dark");
      document.body.style.backgroundColor = "black";
      document.body.style.color = "white";
      showAlert("Dark mode has been enabled","success");
    }
    if (mode === "dark") {
      setMode("light");
      document.body.style.backgroundColor = "white";
      document.body.style.color = "black";
      showAlert("Light mode has been enabled","success");
    }
  }
  return (
  
    <>
    <Router>
      <Navbar title="Suraj Sahani - TextUtils" aboutText="About Us" mode={mode} toggleMode={toggleMode} />
      <Alert alert={alert}></Alert>
      <div className="container mt-2">
      <Routes>
          <Route exact path="/about" element={<About />} />
          <Route exact path="/" element={ <TextForm showAlert={showAlert} heading="Try TextUtils - Word Counter , Character Counter , Remove Extra Spaces !!!" mode={mode}></TextForm>} />
        </Routes>
      
       
      
      </div>
</Router>
    </>
    
  );
}


export default App;
